import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {
  citizenGetServicesGroups
} from 'src/app/store/entities/citizens/citizens-services-groups/citizens-services-groups.actions';
import {
  CitizensServicesGroups
} from 'src/app/store/entities/citizens/citizens-services-groups/citizens-services-groups.model';
import {
  selectModifiedServiceGroup
} from 'src/app/store/entities/citizens/citizens-services-groups/citizens-services-groups.selectors';
import {AppState} from 'src/app/store/reducers';

@Component({
  selector: 'app-citizen-services-service-group',
  templateUrl: './citizen-services-service-group.component.html',
  styleUrls: ['./citizen-services-service-group.component.scss']
})
export class CitizenServicesServiceGroupComponent implements OnInit {


  @Input() serviceUniqueId: string;

  servicesGroup$:Observable<CitizensServicesGroups []>
  constructor(
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private translateService: TranslateService,
  ) { }

  ngOnInit(): void {
    this.store.dispatch(citizenGetServicesGroups({serviceUniqueId:this.serviceUniqueId}));
    this.servicesGroup$ = this.store.select(selectModifiedServiceGroup)

  }

}
